<template>
    <a-card :bordered="false">
  
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :md="6" :sm="12">
              <a-form-item :label="$t('system.user.userFormItem')">
                <a-input :placeholder="$t('system.user.placeholderUserFormItem')" v-model="queryParam.account"></a-input>
              </a-form-item>
            </a-col>

            <template v-if="toggleSearchStatus">
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t('system.user.usernameFormItem')">
                  <a-input :placeholder="$t('system.user.placeholderUsernameFormItem')" v-model="queryParam.username"></a-input>
                </a-form-item>
              </a-col>
  
              <a-col :md="6" :sm="8">
                <a-form-item :label="$t('system.user.siteNameFormItem')">
                  <a-input :placeholder="$t('system.user.placeholderSiteNameFormItem')" v-model="queryParam.siteId"></a-input>
                </a-form-item>
              </a-col>
  
              <!-- <a-col :md="6" :sm="8">
                <a-form-item label="用户状态">
                  <a-select v-model="queryParam.status" placeholder="请选择">
                    <a-select-option value="">请选择</a-select-option>
                    <a-select-option value="1">正常</a-select-option>
                    <a-select-option value="2">冻结</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
            </template>
  
            <a-col :md="6" :sm="8">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('antd.table.search') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('antd.table.reset') }}</a-button>
                <a @click="handleToggleSearch" style="margin-left: 8px">
                  {{ toggleSearchStatus ? $t('antd.table.up') : $t('antd.table.down') }}
                  <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
  
          </a-row>
        </a-form>
      </div>
  
      <!-- 操作按钮区域 -->
      <div class="table-operator" style="border-top: 5px">
        <a-button @click="handleAdd" type="primary" icon="plus" >{{ $t('system.user.addUser') }}</a-button>
        <!-- <a-button type="primary" icon="download" @click="handleExportXls('用户信息')">导出</a-button> -->
        <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
          <a-button type="primary" icon="import">导入</a-button>
        </a-upload> -->
       
        <!-- <a-button type="primary" icon="hdd" @click="recycleBinVisible=true">回收站</a-button> -->
        <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1">
              <a-icon type="delete" @click="batchDel"/>
              {{ $t('antd.table.delect') }}
            </a-menu-item>
            <a-menu-item key="2">
              <a-icon type="lock" @click="batchFrozen('2')"/>
              冻结
            </a-menu-item>
            <a-menu-item key="3">
              <a-icon type="unlock" @click="batchFrozen('1')"/>
              解冻
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            {{ $t('antd.table.batchOperation') }}
          <a-icon type="down"/>
          </a-button>
        </a-dropdown> -->
      </div>
  
      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
          <i class="anticon anticon-info-circle ant-alert-icon"></i>{{ $t('antd.table.selected') }}&nbsp;<a style="font-weight: 600">{{ selectedRowKeys.length }}</a>&nbsp;{{ $t('antd.table.item') }}&nbsp;&nbsp;
          <a style="margin-left: 24px" @click="onClearSelected">{{ $t('antd.table.clear') }}</a>
        </div>
  
        <a-table
          ref="table"
          bordered
          size="middle"
          rowKey="id"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
          @change="handleTableChange">
  
          <template slot="avatarslot" slot-scope="text, record">
            <div class="anty-img-wrap">
              <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user"/>
            </div>
          </template>
  
          <span slot="action" slot-scope="text, record">
            <a @click="handleEdit(record)" >{{  $t('antd.table.edit') }}</a>
  
            <a-divider type="vertical" />
            
            <a-popconfirm :title="$t('antd.table.delectVerify')" @confirm="() => handleDelete(record.id)">
                <a>{{ $t('antd.table.delect') }}</a>
            </a-popconfirm>

            <!-- <a-dropdown>
              <a class="ant-dropdown-link">
                更多 <a-icon type="down"/>
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a href="javascript:;" @click="handleChangePassword(record.id)">密码</a>
                </a-menu-item>
                <a-menu-item v-if="record.status==1">
                  <a-popconfirm title="确定冻结吗?" @confirm="() => handleFrozen(record.id,2,record.username)">
                    <a>冻结</a>
                  </a-popconfirm>
                </a-menu-item>
  
                <a-menu-item v-if="record.status==2">
                  <a-popconfirm title="确定解冻吗?" @confirm="() => handleFrozen(record.id,1,record.username)">
                    <a>解冻</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown> -->
          </span>
        </a-table>
        
        <!-- table区域-end -->
        <UserCreater ref="modalForm" @ok="modalFormOk"></UserCreater>
      </div>
      
      <!-- <user-modal ref="modalForm" @ok="modalFormOk"></user-modal>
  
      <password-modal ref="passwordmodal" @ok="passwordModalOk"></password-modal>
  
      <sys-user-agent-modal ref="sysUserAgentModal"></sys-user-agent-modal> -->
  
      <!-- 用户回收站 -->
      <!-- <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk"/> -->
      <user-password ref="passwordmodal" @ok="passwordModalOk"></user-password>
    </a-card>
  </template>
  
  <script>
  import UserCreater from './modules/UserCreater'
  //import PasswordModal from './modules/PasswordModal'
  //import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  //import {frozenBatch} from '@/api/api'
  import { TableListMixin } from '@/situation/mixins/tableListMixin'
  //import SysUserAgentModal from "./modules/SysUserAgentModal";
  import UserPassword from '@/components/tools/UserPassword'
    export default {
      name: "UserList",
      mixins: [TableListMixin],
      components: {
        UserPassword,
        UserCreater
      },
      data() {
        return {
          description: '这是用户管理页面',
          queryParam: {},
          recycleBinVisible: false,
          columns: [
            /*{
              title: '#',
              dataIndex: '',
              key:'rowIndex',
              width:60,
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },*/
            {
              title: this.$t("system.user.userFormItem"),
              align: "center",
              dataIndex: 'account',
              width: 120
            },
            {
              title: this.$t("system.user.usernameFormItem"),
              align: "center",
              width: 100,
              dataIndex: 'username',
            },
            {
              title: this.$t("system.user.roleNameFormItem"),
              align: "center",
              width: 120,
              dataIndex: 'roleName',
            },
            {
              title: this.$t("system.user.siteNameFormItem"),
              align: "center",
              width: 120,
              dataIndex: 'siteName',
            },
  
            {
              title: this.$t("system.user.phoneFormItem"),
              align: "center",
              width: 80,
              dataIndex: 'phone'
            },
            {
              title: this.$t("system.user.emailFormItem"),
              align: "center",
              width: 100,
              dataIndex: 'email'
            },
            {
              title: this.$t("antd.table.createTime"),
              align: "center",
              width: 100,
              dataIndex: 'createTime'
            },
            {
              title: this.$t("antd.table.batch"),
              dataIndex: 'action',
              scopedSlots: {customRender: 'action'},
              align: "center",
              width: 170
            }
  
          ],
          superQueryFieldList: [
            { type: 'input', value: 'username', text: this.$t("system.user.userFormItem") , },
            { type: 'input', value: 'realname', text: this.$t("system.user.usernameFormItem"), }
          ],
          url: {
            selectData:"/ndt/user/page",
            deleteData:"/ndt/user/delete"
          },
        }
      },
      computed: {
        importExcelUrl: function(){
          return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
        }
      },
      methods: {
        getAvatarView: function (avatar) {
          //return getFileAccessHttpUrl(avatar)
          return avatar
        },
  
        batchFrozen: function (status) {
          if (this.selectedRowKeys.length <= 0) {
            this.$message.warning(this.$t("antd.table.selectOnlyOne"));
            return false;
          } else {
            let ids = "";
            let that = this;
            let isAdmin = false;
            that.selectionRows.forEach(function (row) {
              if (row.username == 'admin') {
                isAdmin = true;
              }
            });
            if (isAdmin) {
              that.$message.warning('管理员账号不允许此操作,请重新选择！');
              return;
            }
            that.selectedRowKeys.forEach(function (val) {
              ids += val + ",";
            });
            that.$confirm({
              title: "确认操作",
              content: "是否" + (status == 1 ? "解冻" : "冻结") + "选中账号?",
              onOk: function () {
                console.log(ids)
                //frozenBatch({ids: ids, status: status}).then((res) => {
                  //if (res.success) {
                    //that.$message.success(res.message);
                    //that.loadData();
                    //that.onClearSelected();
                  //} else {
                    //that.$message.warning(res.message);
                 //}
                //});
              }
            });
          }
        },
        handleMenuClick(e) {
          if (e.key == 1) {
            this.batchDel();
          } else if (e.key == 2) {
            this.batchFrozen(2);
          } else if (e.key == 3) {
            this.batchFrozen(1);
          }
        },
        handleFrozen: function (id, status, username) {
          let that = this;
          //TODO 后台校验管理员角色
          if ('admin' == username) {
            that.$message.warning('管理员账号不允许此操作！');
            return;
          }
         /**  frozenBatch({ids: id, status: status}).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.loadData();
            } else {
              that.$message.warning(res.message);
            }
          });*/
        },
        handleChangePassword(username) {
          this.$refs.passwordmodal.show(username);
        },
        passwordModalOk() {
          //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
        },
        onSyncFinally({isToLocal}) {
          // 同步到本地时刷新下数据
          if (isToLocal) {
            this.loadData()
          }
        },
      }
  
    }
  </script>
  <style lang="less" scoped>
    @import '~@/assets/less/common.less';
  </style>